
import { Component } from 'vue-property-decorator';
import AmountDisplayerFilterable from '@/components/reports-v3/components/filterables/AmountDisplayerFilterable.vue';
import FilterWidget from '@/components/reports-v3/components/codedWidgets/shared/FilterWidget.vue';
import { PermissionsGroup } from '@/store/models.def';
import { getTableName } from '@/worker/db/sqlHelpers';
import moment from 'moment';

@Component({
	components: {
		AmountDisplayerFilterable,
	},
})
export default class BpTotalEquityNumberDisplayer extends FilterWidget {
	public get permissionIds(): PermissionsGroup[] {
		return ['transactions'];
	}

	public filterIds: Array<
		| 'date'
		| 'dateAsOf'
		| 'dateRange'
		| 'stockItems'
		| 'agents'
		| 'customers'
		| 'suppliers'
	> = ['dateAsOf'];

	public amount: number = 0;

	public get expensiveHook() {
		const { selectedAsOfDate } = this;
		return JSON.stringify([selectedAsOfDate]);
	}

	public async expensiveCalc() {
		const table = getTableName('transactions');
		const systemTable = getTableName('system');

		const jobId = this.currentJobId;
		const queryHead = await this._ensureTablesLoaded(['transactions', 'system', 'stockBalances']);
		this.checkInterrupted(jobId);

		this.generateLoadingText(0.3);

		const [accTypeResult, systemResult] = await Promise.all([
			queryHead.rawQuery(`
				SELECT "ACCTYPE", SUM(TRY_CAST("AMOUNT" AS DOUBLE)) as total
				FROM ${table}
				WHERE TRY_CAST("DOCDATE" AS BIGINT) <= ${this.selectedAsOfDate}
					AND "ACCTYPE" IN ('RE', 'EP', 'SL', 'SA', 'OI', 'EO', 'CO', 'TX', 'CP', 'RV', 'AP')
				GROUP BY "ACCTYPE"
			`),
			queryHead.rawQuery(`
				SELECT "VAL" FROM ${systemTable} LIMIT 1
			`),
		]);
		this.checkInterrupted(jobId);

		const sumByType: Record<string, number> = {};
		for (const row of accTypeResult) {
			sumByType[row.ACCTYPE] = Number(row.total) || 0;
		}
		const g = (key: string) => sumByType[key] || 0;

		const startFinancialYear = systemResult[0] && systemResult[0].VAL;

		const stockBalance = await this._getStockMovement(queryHead, [
			moment(startFinancialYear, 'DD/MM/YYYY').valueOf(),
			this.selectedAsOfDate,
		]);

		const equity = g('CP') + g('RE') + g('RV') + g('AP');
		const netSales = g('SL') + g('SA') + g('OI') + g('EO');
		const expenses = g('EP');
		const COGS = g('CO');
		const tax = g('TX');

		// GL signs: netSales is negative (credit), COGS is positive (debit)
		// stockBalance: positive = stock decreased, negative = stock increased
		// Adjusted COGS = COGS + stockBalance
		const adjustedCOGS = COGS + stockBalance;
		const grossProfit = -netSales - adjustedCOGS;

		const netProfitBeforeTax = grossProfit - expenses;

		// equity is negative in GL (credit), negate to get positive
		this.amount = -equity + netProfitBeforeTax - tax;

		this.saveHistory('amount');
	}
}
